<template>
	<button
		class="player-overlay__back-button"
		@click.stop="handleBack"
	>
		<Icon
			icon-name="e-remove"
			size="lg"
		/>
	</button>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'BackButton',
	components: { Icon },
	props:      {
		backUrl: {
			type:    String,
			default: null,
		},
		isFullscreen: {
			type:    Boolean,
			default: false,
		},
	},
	methods: {
		handleBack() {
			if (this.isFullscreen) {
				this.$emit('close-fullscreen');
			} else if (this.backUrl) {
				window.location.href = this.backUrl;
			} else if (window.history.length > 1) {
				window.history.back();
			} else {
				window.location.href = window.location.origin;
			}
		},
	},
};
</script>
